'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _RenderSpot = require('../RenderSpot');

var _RenderSpot2 = _interopRequireDefault(_RenderSpot);

var _RenderSubregion = require('../RenderSubregion');

var _RenderSubregion2 = _interopRequireDefault(_RenderSubregion);

var _Chevron = require('../Chevron');

var _Chevron2 = _interopRequireDefault(_Chevron);

var _fetchSpotReportViews = require('../helpers/fetchSpotReportViews');

var _fetchSpotReportViews2 = _interopRequireDefault(_fetchSpotReportViews);

var _taxonomyNodePropType = require('../PropTypes/taxonomyNodePropType');

var _taxonomyNodePropType2 = _interopRequireDefault(_taxonomyNodePropType);

var _serviceConfigurationPropType = require('../PropTypes/serviceConfigurationPropType');

var _serviceConfigurationPropType2 = _interopRequireDefault(_serviceConfigurationPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecentlyVisited = function (_Component) {
  (0, _inherits3.default)(RecentlyVisited, _Component);

  function RecentlyVisited(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, RecentlyVisited);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RecentlyVisited.__proto__ || (0, _getPrototypeOf2.default)(RecentlyVisited)).call(this, props));

    _this.componentDidMount = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      var nodes, spotIds, _ref2, data;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              nodes = _this.props.items || [];

              if (!(_this.props.listType === 'subregions')) {
                _context.next = 5;
                break;
              }

              _this.setState({
                nodes: nodes
              });
              _context.next = 11;
              break;

            case 5:
              spotIds = nodes.map(function (spot) {
                return spot._id;
              });
              _context.next = 8;
              return (0, _fetchSpotReportViews2.default)(spotIds, _this.props.serviceConfig);

            case 8:
              _ref2 = _context.sent;
              data = _ref2.data;

              _this.setState({
                nodes: nodes.map(function (item) {
                  return (0, _extends3.default)({}, item, data.find(function (d) {
                    return d._id === item._id;
                  }));
                })
              });

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.toggleShowList = function () {
      return _this.setState({ open: !_this.state.open });
    };

    _this.headerClassName = function () {
      return (0, _classnames2.default)({
        'quiver-recently-visited__header': true,
        'quiver-recently-visited__header--open': _this.state.open
      });
    };

    _this.listClassName = function () {
      return (0, _classnames2.default)({
        'quiver-recently-visited__list': true,
        'quiver-recently-visited__list--hidden': !_this.state.open
      });
    };

    _this.state = {
      nodes: [],
      open: false
    };
    return _this;
  }

  (0, _createClass3.default)(RecentlyVisited, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loggedIn = _props.loggedIn,
          listType = _props.listType,
          staticLinks = _props.staticLinks,
          _onClickLink = _props.onClickLink,
          signInUrl = _props.signInUrl;
      var nodes = this.state.nodes;

      return _react2.default.createElement(
        'div',
        { className: 'quiver-recently-visited' },
        _react2.default.createElement(
          'button',
          {
            className: this.headerClassName(),
            onClick: this.toggleShowList
          },
          _react2.default.createElement(
            'div',
            { className: 'quiver-recently-visited__header__button-wrapper' },
            'Recently Visited',
            _react2.default.createElement(_Chevron2.default, { direction: 'right' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: this.listClassName() },
          function () {
            if (!loggedIn) {
              return _react2.default.createElement(
                'div',
                { className: 'quiver-recently-visited__list__sign-in' },
                _react2.default.createElement(
                  'a',
                  {
                    href: signInUrl,
                    className: 'quiver-recently-visited__list__sign-in__link',
                    onClick: function onClick() {
                      return _onClickLink({
                        locationCategory: 'Recently Visited',
                        clickEndLocation: 'sign-in',
                        destinationUrl: signInUrl,
                        completion: true,
                        linkName: 'Sign in or create account'
                      }, true);
                    }
                  },
                  'Sign in or create account'
                ),
                ' to view your recently visited ' + listType
              );
            } else if (listType === 'subregions') {
              return nodes.filter(function (node) {
                return !!node._id && !!node.name;
              }).map(function (node) {
                return _react2.default.createElement(_RenderSubregion2.default, {
                  subregion: node,
                  key: node._id,
                  onClickLink: function onClickLink(properties, closeMobileMenu) {
                    return _onClickLink((0, _extends3.default)({}, properties, {
                      locationCategory: 'Recently Visited'
                    }), closeMobileMenu);
                  }
                });
              });
            } else if (listType === 'spots') {
              return nodes.filter(function (node) {
                return !!node._id && !!node.name;
              }).map(function (node) {
                return _react2.default.createElement(_RenderSpot2.default, {
                  spot: node,
                  key: node._id,
                  onClickLink: function onClickLink(properties, closeMobileMenu) {
                    return _onClickLink((0, _extends3.default)({}, properties, {
                      locationCategory: 'Recently Visited'
                    }), closeMobileMenu);
                  }
                });
              });
            }
            return null;
          }()
        ),
        _react2.default.createElement(
          'div',
          { className: 'quiver-recently-visited__static-links' },
          function () {
            if (listType === 'subregions') {
              return _react2.default.createElement(
                'div',
                { className: 'quiver-recently-visited__header' },
                'Forecast Tools'
              );
            }
            return null;
          }(),
          staticLinks.map(function (link) {
            return _react2.default.createElement(
              'a',
              {
                className: 'quiver-recently-visited__static-link',
                href: link.href,
                key: link.display,
                target: link.newWindow ? '_blank' : '',
                onClick: function onClick() {
                  return _onClickLink({
                    locationCategory: 'Tools',
                    clickEndLocation: 'Tools',
                    destinationUrl: link.href,
                    completion: true,
                    linkName: link.display
                  }, true);
                }
              },
              link.display
            );
          })
        )
      );
    }
  }]);
  return RecentlyVisited;
}(_react.Component);

RecentlyVisited.propTypes = {
  loggedIn: _propTypes2.default.bool,
  items: _propTypes2.default.arrayOf(_taxonomyNodePropType2.default),
  listType: _propTypes2.default.string,
  serviceConfig: _serviceConfigurationPropType2.default,
  staticLinks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    href: _propTypes2.default.string,
    display: _propTypes2.default.string
  })),
  signInUrl: _propTypes2.default.string.isRequired,
  onClickLink: _propTypes2.default.func
};

RecentlyVisited.defaultProps = {
  staticLinks: [],
  onClickLink: null
};

exports.default = RecentlyVisited;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/RecentlyVisited/RecentlyVisited.js
// module id = 635
// module chunks = 11